export type Subject = {
  slug: string;
  name: string;
  tagline: string;
  description: string;
  emoji: string;
  color: string;
  available: boolean;
  units?: { title: string; lessons: number; free?: boolean }[];
};

export const subjects: Subject[] = [
  {
    slug: "romanian",
    name: "Limba și literatura română",
    tagline: "De la Eminescu la Cărtărescu",
    description:
      "Un parcurs complet prin literatura română — curentele, autorii și operele care intră la BAC, de la pașoptiști la postmodernism.",
    emoji: "📖",
    color: "from-primary to-accent",
    available: true,
    units: [
      { title: "Literatura română — curente literare", lessons: 56, free: true },
      { title: "Romanul românesc", lessons: 30 },
      { title: "Dramaturgie", lessons: 12 },
      { title: "Limba română", lessons: 27 },
    ],
  },
  { slug: "math", name: "Matematică", tagline: "Logică și frumusețe", description: "În curând.", emoji: "✏️", color: "from-tertiary to-secondary", available: false },
  { slug: "history", name: "Istorie", tagline: "Povestea noastră", description: "În curând.", emoji: "🏛️", color: "from-accent to-primary", available: false },
  { slug: "physics", name: "Fizică", tagline: "Legile universului", description: "În curând.", emoji: "⚛️", color: "from-primary to-secondary", available: false },
  { slug: "chemistry", name: "Chimie", tagline: "Reacții și molecule", description: "În curând.", emoji: "🧪", color: "from-accent to-tertiary", available: false },
  { slug: "biology", name: "Biologie", tagline: "Viața în detaliu", description: "În curând.", emoji: "🌱", color: "from-secondary to-tertiary", available: false },
  { slug: "geography", name: "Geografie", tagline: "Lumea pe hartă", description: "În curând.", emoji: "🗺️", color: "from-tertiary to-primary", available: false },
  { slug: "logic", name: "Logică și argumentare", tagline: "Gândire critică", description: "În curând.", emoji: "🧠", color: "from-primary to-accent", available: false },
  { slug: "psychology", name: "Psihologie", tagline: "Mintea umană", description: "În curând.", emoji: "🧩", color: "from-secondary to-primary", available: false },
  { slug: "sociology", name: "Sociologie", tagline: "Oamenii și societatea", description: "În curând.", emoji: "👥", color: "from-accent to-secondary", available: false },
  { slug: "economics", name: "Economie", tagline: "Piețe și decizii", description: "În curând.", emoji: "📈", color: "from-tertiary to-accent", available: false },
  { slug: "philosophy", name: "Filosofie", tagline: "Întrebările esențiale", description: "În curând.", emoji: "💭", color: "from-primary to-tertiary", available: false },
  
];

export const team = [
  { name: "Andrei Popescu", role: "Fondator & profesor de română", bio: "15 ani la catedră, pasionat de literatura interbelică.", initials: "AP" },
  { name: "Maria Ionescu", role: "Director pedagogic", bio: "Doctor în științele educației, designer de curriculum.", initials: "MI" },
  { name: "Vlad Dumitrescu", role: "Lead developer", bio: "Construiește instrumente care fac învățarea să fie un joc.", initials: "VD" },
  { name: "Ioana Marin", role: "Designer & ilustrator", bio: "Crede că un manual frumos se citește mai cu drag.", initials: "IM" },
];

export const faqs = [
  { q: "Cât costă Self Educate?", a: "În perioada de beta deschisă, platforma este complet gratuită pentru toți elevii. Nu este nevoie de card, abonament sau plată. Tu ne ajuți cu feedback, noi îți dăm acces complet." },
  { q: "Trebuie să introduc un card?", a: "Nu. Beta-ul nu cere date de plată. Te înregistrezi cu email și parolă și ai acces imediat la tot conținutul." },
  { q: "Ce conține accesul gratuit din beta?", a: "Toate materiile, lecțiile, recapitulările, eseurile model, simulările BAC și arhiva — fără limitări. Singurul lucru pe care ți-l cerem este să ne spui ce funcționează și ce trebuie îmbunătățit." },
  { q: "Ce se întâmplă după beta?", a: "Te anunțăm din timp pe email, prin cont, înainte să schimbăm ceva. Beta-testerii vor avea condiții preferențiale când vom introduce planuri plătite." },
  { q: "Materialele sunt descărcabile?", a: "Da — toate lecțiile au PDF-uri descărcabile pentru recapitulare offline." },
  { q: "Pe ce dispozitive funcționează?", a: "Pe orice browser modern: telefon, tabletă, laptop. Nu trebuie să instalezi nimic." },
  { q: "Cine scrie materialele?", a: "Profesori cu experiență, fiecare specializat pe materia lui, în colaborare cu echipa noastră pedagogică și absolvenți recenți cu peste 9 la BAC." },
  { q: "Există suport pentru elevi?", a: "Da. Lucrăm la o comunitate „elevi pentru elevi” unde poți pune întrebări și primi răspunsuri de la colegi și mentori. Pentru orice altceva, ne scrii pe email și răspundem rapid." },
];
